import { render, staticRenderFns } from "./Recepcionista.vue?vue&type=template&id=8bbff576"
import script from "./Recepcionista.vue?vue&type=script&lang=js"
export * from "./Recepcionista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports